import { APICommonResponse, ApiId, HttpMethod, makeParam, request } from "api";
import { getUrl } from "./url";

export type 店舗 = {
  shop_id: string;
  deposit: number;
  name: string;
  qr_service_expire_min: number;
  under_amount_when_create: number;
  under_amount_when_auth: number;
  under_amount_when_use: number;
  balance_alert_threshold: number | null;
};

export type QRサービス券認証設定 = {
  shop_no: number;
  parking_management_code: string;
  parking_name: string;
  discount_ticket_code: number | null;
  is_deposit_check: boolean;
};
export type QRサービス券印字設定 = {
  shop_no: number;
  parking_management_code: string;
  parking_name: string;
  is_deposit_check: boolean;
};
export type QRサービス券取得設定 = {
  id: string;
  shop_id: string;
  qr_service_parking_group_id: string;
  group_name: string | null;
  shop_no: number;
  discount_ticket_code: number;
  sort_no: number;
  is_deposit_check: boolean;
};
export type 残高異動履歴 = {
  transfer_datetime: Date;
  transfer_reason: string | null;
  parking_name: string | null;
  transfer_amount: number;
  before_amount: number;
  after_amount: number;
  discount_ticket_code: number | null;
  discount_ticket_name: string | null;
  shop_no: number | null;
  shop_name: string | null;
};

// -------店舗一覧取得---------------
export type 店舗一覧取得Request = {
  shop_id?: string;
  email?: string;
  name?: string;
  sort_key?: string;
  sort_order?: "asc" | "desc";
};
export type 店舗一覧取得Response = {
  data: {
    list: 店舗[];
  };
} & APICommonResponse;
export const 店舗一覧取得 = async (param: 店舗一覧取得Request) => {
  const res = await request<店舗一覧取得Response>({
    url: getUrl(ApiId.店舗一覧取得),
    method: HttpMethod.GET,
    data: new URLSearchParams(param),
  });
  return res;
};

// -------店舗新規登録---------------
export type 店舗新規登録Request = {
  name: string;
};
export type 店舗新規登録Response = {
  data: {
    shop_id: string;
  };
} & APICommonResponse;
export const 店舗新規登録 = async (param: 店舗新規登録Request) => {
  const res = await request<店舗新規登録Response>({
    url: getUrl(ApiId.店舗新規登録),
    method: HttpMethod.POST,
    data: makeParam(param),
  });
  return res;
};

// -------店舗削除---------------
export type 店舗削除Request = {
  shop_id: string;
};
export type 店舗削除Response = {} & APICommonResponse;
export const 店舗削除 = async (param: 店舗削除Request) => {
  const res = await request<店舗削除Response>({
    url: getUrl(ApiId.店舗削除),
    method: HttpMethod.POST,
    data: makeParam(param),
  });
  return res;
};

// -------残高情報取得---------------
export type 残高情報取得Request = {};
export type 残高情報取得Response = {
  data: {
    deposit: number;
  };
} & APICommonResponse;
export const 残高情報取得 = async (param: 残高情報取得Request) => {
  const res = await request<残高情報取得Response>({
    url: getUrl(ApiId.残高情報取得),
    method: HttpMethod.GET,
  });
  return res;
};
// -------残高異動履歴一覧取得---------------
export type 残高異動履歴一覧取得Request = {
  sort_key?: string;
  sort_order?: "asc" | "desc";
  transfer_date_from?: string;
  transfer_date_to?: string;
  search_text?: string;
  shop_id?: string;
};
export type 残高異動履歴一覧取得Response = {
  data: {
    list: 残高異動履歴[];
  };
} & APICommonResponse;
export const 残高異動履歴一覧取得 = async (param: 残高異動履歴一覧取得Request) => {
  const res = await request<残高異動履歴一覧取得Response>({
    url: getUrl(ApiId.残高異動履歴一覧取得),
    method: HttpMethod.GET,
    data: new URLSearchParams(param),
  });
  return res;
};

// -------残高チャージ---------------
export type 残高チャージRequest = {
  shop_id: string;
  amount: string;
};
export type 残高チャージResponse = {
  data: {
    shop_id: string;
    deposit: number;
  };
} & APICommonResponse;
export const 残高チャージ = async (param: 残高チャージRequest) => {
  const res = await request<残高チャージResponse>({
    url: getUrl(ApiId.残高チャージ),
    method: HttpMethod.POST,
    data: makeParam(param),
  });
  return res;
};

// -------店舗設定---------------
export type 店舗設定Request = {
  shop_id: string;
  shop_name: string;
  qr_service_expire_min: string;
  under_amount_when_create: string;
  under_amount_when_auth: string;
  under_amount_when_use: string;
  balance_alert_threshold: number | null;
};
export type 店舗設定Response = {
  data: {
    shop_id: string;
  };
} & APICommonResponse;
export const 店舗設定 = async (param: 店舗設定Request) => {
  const res = await request<店舗設定Response>({
    url: getUrl(ApiId.店舗設定),
    method: HttpMethod.POST,
    data: makeParam(param),
  });
  return res;
};

// -------店舗QR設定取得---------------
export type 店舗QR設定取得Request = {
  shop_id: string;
};
export type 店舗QR設定取得Response = {
  data: {
    shop_id: string;
    certification: QRサービス券認証設定[];
    printing: QRサービス券印字設定[];
    acquisition: QRサービス券取得設定[] | null;
  };
} & APICommonResponse;
export const 店舗QR設定取得 = async (param: 店舗QR設定取得Request) => {
  const res = await request<店舗QR設定取得Response>({
    url: getUrl(ApiId.店舗QR設定取得),
    method: HttpMethod.GET,
    data: new URLSearchParams(param),
  });
  return res;
};

// -------店舗QR設定認証設定新規登録---------------
export type 店舗QR設定認証設定新規登録Request = {
  shop_id: string;
  parking_management_code: string;
  shop_no: string;
  is_deposit_check: boolean;
};
export type 店舗QR設定認証設定新規登録Response = {} & APICommonResponse;
export const 店舗QR設定認証設定新規登録 = async (param: 店舗QR設定認証設定新規登録Request) => {
  const res = await request<店舗QR設定認証設定新規登録Response>({
    url: getUrl(ApiId.店舗QR設定認証設定新規登録),
    method: HttpMethod.POST,
    data: makeParam(param),
  });
  return res;
};

// -------店舗QR設定認証設定更新---------------
export type 店舗QR設定認証設定更新Request = {
  shop_id: string;
  parking_management_code: string;
  shop_no: string;
  is_deposit_check?: boolean;
};
export type 店舗QR設定認証設定更新Response = {} & APICommonResponse;
export const 店舗QR設定認証設定更新 = async (param: 店舗QR設定認証設定更新Request) => {
  const res = await request<店舗QR設定認証設定更新Response>({
    url: getUrl(ApiId.店舗QR設定認証設定更新),
    method: HttpMethod.POST,
    data: makeParam(param),
  });
  return res;
};

// -------店舗QR設定認証設定追加---------------
export type 店舗QR設定認証設定追加Request = {
  shop_id: string;
  parking_management_code: string;
  discount_ticket_code: string;
  is_deposit_check?: boolean;
};
export type 店舗QR設定認証設定追加Response = {} & APICommonResponse;
export const 店舗QR設定認証設定追加 = async (param: 店舗QR設定認証設定追加Request) => {
  const res = await request<店舗QR設定認証設定追加Response>({
    url: getUrl(ApiId.店舗QR設定認証設定追加),
    method: HttpMethod.POST,
    data: makeParam(param),
  });
  return res;
};

// -------店舗QR設定認証設定削除---------------
export type 店舗QR設定認証設定削除Request = {
  shop_id: string;
  parking_management_code: string;
  discount_ticket_code: string;
};
export type 店舗QR設定認証設定削除Response = {} & APICommonResponse;
export const 店舗QR設定認証設定削除 = async (param: 店舗QR設定認証設定削除Request) => {
  const res = await request<店舗QR設定認証設定削除Response>({
    url: getUrl(ApiId.店舗QR設定認証設定削除),
    method: HttpMethod.POST,
    data: makeParam(param),
  });
  return res;
};

// -------店舗QR設定認証設定削除---------------
export type 店舗QR設定認証設定全削除Request = {
  shop_id: string;
  parking_management_code: string;
};
export type 店舗QR設定認証設定全削除Response = {} & APICommonResponse;
export const 店舗QR設定認証設定全削除 = async (param: 店舗QR設定認証設定全削除Request) => {
  const res = await request<店舗QR設定認証設定全削除Response>({
    url: getUrl(ApiId.店舗QR設定認証設定全削除),
    method: HttpMethod.POST,
    data: makeParam(param),
  });
  return res;
};

// -------店舗QR設定印字設定変更---------------
export type 店舗QR設定印字設定変更Request = {
  shop_id: string;
  parking_management_code: string;
  shop_no: string;
  is_deposit_check: boolean;
};
export type 店舗QR設定印字設定変更Response = {} & APICommonResponse;
export const 店舗QR設定印字設定変更 = async (param: 店舗QR設定印字設定変更Request) => {
  const res = await request<店舗QR設定印字設定変更Response>({
    url: getUrl(ApiId.店舗QR設定印字設定変更),
    method: HttpMethod.POST,
    data: makeParam(param),
  });
  return res;
};

// -------店舗QR設定印字設定無効化---------------
export type 店舗QR設定印字設定無効化Request = {
  shop_id: string;
  parking_management_code: string;
};
export type 店舗QR設定印字設定無効化Response = {} & APICommonResponse;
export const 店舗QR設定印字設定無効化 = async (param: 店舗QR設定印字設定無効化Request) => {
  const res = await request<店舗QR設定印字設定無効化Response>({
    url: getUrl(ApiId.店舗QR設定印字設定無効化),
    method: HttpMethod.POST,
    data: makeParam(param),
  });
  return res;
};

// -------店舗QR設定取得設定変更---------------
/** @deprecated */
export type 店舗QR設定取得設定変更Request = {
  shop_id: string;
  qr_service_parking_group_id: string;
  shop_no: string;
  discount_ticket_code: string;
};
/** @deprecated */
export type 店舗QR設定取得設定変更Response = {} & APICommonResponse;
/** @deprecated */
export const 店舗QR設定取得設定変更 = async (param: 店舗QR設定取得設定変更Request) => {
  const res = await request<店舗QR設定取得設定変更Response>({
    url: getUrl(ApiId.店舗QR設定取得設定変更),
    method: HttpMethod.POST,
    data: makeParam(param),
  });
  return res;
};

// -------店舗QR設定取得設定無効化---------------
/** @deprecated */
export type 店舗QR設定取得設定無効化Request = {
  shop_id: string;
};
/** @deprecated */
export type 店舗QR設定取得設定無効化Response = {} & APICommonResponse;
/** @deprecated */
export const 店舗QR設定取得設定無効化 = async (param: 店舗QR設定取得設定無効化Request) => {
  const res = await request<店舗QR設定取得設定無効化Response>({
    url: getUrl(ApiId.店舗QR設定取得設定無効化),
    method: HttpMethod.POST,
    data: makeParam(param),
  });
  return res;
};

// -------店舗QR設定取得設定一覧取得---------------
export type 店舗QR設定取得設定一覧取得Request = {
  shop_id: string;
};
export type 店舗QR設定取得設定一覧取得Response = {
  data: {
    list: QRサービス券取得設定[];
  };
} & APICommonResponse;
export const 店舗QR設定取得設定一覧取得 = async (param: 店舗QR設定取得設定一覧取得Request) => {
  const res = await request<店舗QR設定取得設定一覧取得Response>({
    url: getUrl(ApiId.店舗QR設定取得設定一覧取得),
    method: HttpMethod.GET,
    data: new URLSearchParams(param),
  });
  return res;
};

// -------店舗QR設定取得設定新規登録---------------
export type 店舗QR設定取得設定新規登録Request = {
  shop_id: string;
  qr_service_parking_group_id: string;
  shop_no: string;
  discount_ticket_code: string;
  is_deposit_check: boolean;
};
export type 店舗QR設定取得設定新規登録Response = {} & APICommonResponse;
export const 店舗QR設定取得設定新規登録 = async (param: 店舗QR設定取得設定新規登録Request) => {
  const res = await request<店舗QR設定取得設定新規登録Response>({
    url: getUrl(ApiId.店舗QR設定取得設定新規登録),
    method: HttpMethod.POST,
    data: makeParam(param),
  });
  return res;
};

// -------店舗QR設定取得設定更新---------------
export type 店舗QR設定取得設定更新Request = {
  id: string;
  shop_id: string;
  qr_service_parking_group_id: string;
  shop_no: string;
  discount_ticket_code: string;
  is_deposit_check: boolean;
  sort_no: number;
};
export type 店舗QR設定取得設定更新Response = {} & APICommonResponse;
export const 店舗QR設定取得設定更新 = async (param: 店舗QR設定取得設定更新Request) => {
  const res = await request<店舗QR設定取得設定更新Response>({
    url: getUrl(ApiId.店舗QR設定取得設定更新),
    method: HttpMethod.POST,
    data: makeParam(param),
  });
  return res;
};

// -------店舗QR設定取得設定削除---------------
export type 店舗QR設定取得設定削除Request = {
  id: string;
  shop_id: string;
};
export type 店舗QR設定取得設定削除Response = {} & APICommonResponse;
export const 店舗QR設定取得設定削除 = async (param: 店舗QR設定取得設定削除Request) => {
  const res = await request<店舗QR設定取得設定削除Response>({
    url: getUrl(ApiId.店舗QR設定取得設定削除),
    method: HttpMethod.POST,
    data: makeParam(param),
  });
  return res;
};

// -------店舗QR設定認証可能設定更新---------------
export type 店舗QR設定認証可能設定更新Request = {
  shop_id: string;
  parking_management_code: string;
  discount_ticket_code: number;
  is_deposit_check: boolean;
};
export type 店舗QR設定認証可能設定更新Response = {} & APICommonResponse;
export const 店舗QR設定認証可能設定更新 = async (param: 店舗QR設定認証可能設定更新Request) => {
  const res = await request<店舗QR設定認証可能設定更新Response>({
    url: getUrl(ApiId.店舗QR設定認証可能設定更新),
    method: HttpMethod.POST,
    data: makeParam(param),
  });
  return res;
};
// -------印刷プリセット一覧取得---------------
export type PrinterPreset = {
  id: string;
  shop_id: string;
  name: string;
  shop_no: number;
  discount_ticket_code: string;
  publishing_terminal_code: string;
  discount_ticket_parking_code: string;
  parking_name: string;
  footer_text: string;
  title: string;
  subtitle: string;
  text1: string;
  text2: string;
  show_created_datetime: boolean;
  show_expiration_datetime: boolean;
  created_at: string;
  updated_at: string;
};
export type 印刷プリセット一覧取得Request = {
  shop_id: string;
};
export type 印刷プリセット一覧取得Response = {
  data: {
    presets: PrinterPreset[];
  };
} & APICommonResponse;
export const 印刷プリセット一覧取得 = async (param: 印刷プリセット一覧取得Request) => {
  const res = await request<印刷プリセット一覧取得Response>({
    url: getUrl(ApiId.印刷プリセット一覧取得),
    method: HttpMethod.GET,
    data: new URLSearchParams(makeParam(param)),
  });
  return res;
};

// -------印刷プリセット登録---------------
export type 印刷プリセット登録Request = {
  shop_id: string;
  name: string;
  shop_no: number;
  discount_ticket_code: string;
  publishing_terminal_code: string;
  discount_ticket_parking_code: string;
  parking_name: string;
  footer_text: string;
  title: string;
  subtitle: string;
  text1: string;
  text2: string;
  show_created_datetime: boolean;
  show_expiration_datetime: boolean;
};
export type 印刷プリセット登録Response = {
  data: {
    result: boolean;
  };
} & APICommonResponse;
export const 印刷プリセット登録 = async (param: 印刷プリセット登録Request) => {
  const res = await request<印刷プリセット登録Response>({
    url: getUrl(ApiId.印刷プリセット登録),
    method: HttpMethod.POST,
    data: makeParam(param),
  });
  return res;
};

// -------印刷プリセット更新---------------
export type 印刷プリセット更新Request = {
  id: string;
  shop_id: string;
  name: string;
  shop_no: number;
  discount_ticket_code: string;
  publishing_terminal_code: string;
  discount_ticket_parking_code: string;
  parking_name: string;
  footer_text: string;
  title: string;
  subtitle: string;
  text1: string;
  text2: string;
  show_created_datetime: boolean;
  show_expiration_datetime: boolean;
};
export type 印刷プリセット更新Response = {
  data: {
    result: boolean;
  };
} & APICommonResponse;
export const 印刷プリセット更新 = async (param: 印刷プリセット更新Request) => {
  const res = await request<印刷プリセット更新Response>({
    url: getUrl(ApiId.印刷プリセット更新),
    method: HttpMethod.POST,
    data: makeParam(param),
  });
  return res;
};

// -------印刷プリセット削除---------------
export type 印刷プリセット削除Request = {
  id: string;
};
export type 印刷プリセット削除Response = {
  data: {
    result: boolean;
  };
} & APICommonResponse;
export const 印刷プリセット削除 = async (param: 印刷プリセット削除Request) => {
  const res = await request<印刷プリセット削除Response>({
    url: getUrl(ApiId.印刷プリセット削除),
    method: HttpMethod.POST,
    data: makeParam(param),
  });
  return res;
};
